import styled from 'styled-components';

export const ButtonContainer = styled.div`
  display: flex;
  justify-content: end;
  gap: 20px;
  margin: 20px 20px 0px 0px;
  margin-bottom: 20px;
`;
